export const AUDIT_PERMISSION_CODES = {
  WEB_BH_AUDIT_LIST: 'WEB_BH_AUDIT_LIST',
  WEB_BH_AUDIT_ALL_MANG: 'WEB_BH_AUDIT_ALL_MANG',
} as const

/** Giá trị query `phamVi` khi xem nhật ký tất cả mảng (cần WEB_BH_AUDIT_ALL_MANG). */
export const AUDIT_PHAM_VI_TAT_CA = 'tat-ca'
